module.exports = __webpack_public_path__ + "static/media/logo.a3f24ba1.png";